import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVisit } from '@/lib/api';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackVisit({
      page: location.pathname,
      referrer: document.referrer || '',
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      language: navigator.language || '',
      user_agent: navigator.userAgent || '',
    });
  }, [location.pathname]);
}
